/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-05-18 09:16:44
 * @LastEditors: loong
 * @LastEditTime: 2022-09-09 16:22:22
 */
import * as config from "./config.js"

export const account = {
  // 获取天气接口 默认返回当前ip地址地区内容 如需其他city=包头, #城市名称
  weather: 'https://www.tianqiapi.com/free/day?appid=58456678&appsecret=LuIS4HCe'
}
export const home = {
  userInfo: (config.flag ? config.proPrefix : config.devPrefix) + '/api/userInfo',//测试
}
